import { combineReducers } from 'redux'
export const SET_LAST_CLICKED_ITEM_ID = 'GLOBAL/SET_LAST_CLICKED_ITEM_ID'
export const SET_CURRENT_PAGE_SCROLL_Y = 'GLOBAL/SET_CURRENT_PAGE_SCROLL_Y'

export const setLastClickedItemId = (lastClickedItemId) => {
    return {
        type: SET_LAST_CLICKED_ITEM_ID,
        payload: lastClickedItemId,
    }
}

export const setCurrentPageScrollY = (page, scrollY) => {
    return {
        type: SET_CURRENT_PAGE_SCROLL_Y,
        payload: {
            page,
            scrollY,
        },
    }
}

const initialState = {
    lastClickedItemId: '-1',
    lastScrollYPerPage: [{ page: 0, scrollY: 0 }],
}

function globalReducer(state = initialState, action) {
    switch (action.type) {
        case 'GLOBAL/SET_LAST_CLICKED_ITEM_ID':
            return {
                ...state,
                lastClickedItemId: action.payload,
            }
        case 'GLOBAL/SET_CURRENT_PAGE_SCROLL_Y': {
            const { page, scrollY } = action.payload

            const filtedList = state.lastScrollYPerPage.filter((element) => {
                return element.page !== page
            })

            const nextList = [
                ...filtedList,
                {
                    page,
                    scrollY,
                },
            ]

            return {
                ...state,
                lastScrollYPerPage: nextList,
            }
        }
        default: {
            return state
        }
    }
}

const rootReducer = combineReducers({
    globalReducer,
})

export default rootReducer



// WEBPACK FOOTER //
// ./Src/Redux/reducer.js